import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CommentsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
});
